import { hideSlidePanel } from 'aria-viewer/slidepanel/slidePanelActions'
import { TABS } from 'aria-viewer/tour/constants'

export const SET_SUPPLEMENTAL_MEDIA_TAB = '|A|SET_SUPPLEMENTAL_MEDIA_TAB'
export const SHOW_INFO = '|A|SHOW_INFO'
export const HIDE_INFO = 'HIDE_INFO'
export const SHOW_SUPPLEMENTAL_MEDIA_VIEW = '|A|SHOW_SUPPLEMENTAL_MEDIA_VIEW'
export const HIDE_SUPPLEMENTAL_MEDIA_VIEW = 'HIDE_SUPPLEMENTAL_MEDIA_VIEW'
export const SET_MEDIA = 'SET_MEDIA'
export const SHOW_PREVIEW = '|A|SHOW_PREVIEW'
export const NEXT_MEDIA = '|A|SupplementalMediaActions.NEXT_MEDIA'
export const INFO_ICON_CLICKED = '|A|SupplementalMediaActions.INFO_ICON_CLICKED'
export const VIDEO_VIEWED = '|A|SupplementalMediaActions.VIDEO_VIEWED'
export const VIDEO_FULL_SCREEN = '|A|SupplementalMediaActions.VIDEO_FULL_SCREEN'
export const PANO_LOADED = '|A|SupplementalMediaActions.PANO_LOADED'
export const SHARE_CLICKED = '|A|SupplementalMediaActions.SHARE_CLICKED'

export const setSupplementalMediaTab = option => ({
    type: SET_SUPPLEMENTAL_MEDIA_TAB,
    option,
})

export const showInfo = () => {
    return {
        type: SHOW_INFO,
    }
}

export const hideInfo = () => {
    return {
        type: HIDE_INFO,
    }
}

export const setMedia = (media, stopid) => [
    {
        type: SET_MEDIA,
        media: media,
        stopid: stopid,
    },
    {
        type: SET_SUPPLEMENTAL_MEDIA_TAB,
        option: media
            ? {
                  panorama: TABS.panos,
                  video: TABS.videos,
                  photo: TABS.photos,
              }[media.mediaType]
            : '',
    },
]

export const nextMedia = () => ({
    type: NEXT_MEDIA,
})

export const showSupplementalMediaView = ({ stopid, media, showAllMedia = false }) => [
    hideSlidePanel(),
    {
        type: SHOW_SUPPLEMENTAL_MEDIA_VIEW,
        showAllMedia,
    },
    ...setMedia(media, stopid),
]

export const hideSupplementalMediaView = () => {
    return {
        type: HIDE_SUPPLEMENTAL_MEDIA_VIEW,
    }
}

export const showSupplementalMediaPreview = visible => ({
    type: SHOW_PREVIEW,
    visible,
})

export const onInfoIconClicked = mediaType => ({
    type: INFO_ICON_CLICKED,
    mediaType,
})

export const onVideoViewed = () => ({
    type: VIDEO_VIEWED,
})

export const onVideoFullScreen = () => ({
    type: VIDEO_FULL_SCREEN,
})

export const onPanoLoaded = () => ({
    type: PANO_LOADED,
})

export const onShareClicked = () => ({
    type: SHARE_CLICKED,
})
